import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Focus on the process, not the goal",
  "description": "",
  "published": "2019-01-11T00:00:00.000Z",
  "redirect_from": ["/blog/focus-process-not-goal/swizec/8866"],
  "categories": "Learning, Personal, Thoughts",
  "hero": "./img/8a3b44ee4261472e4cda4cda6d0de006-tumblr_mv0d3hiVqt1snexhzo1_1280.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote">{`A goal is not always meant to be reached, it often serves simply as something to aim at.`}</p>
    </blockquote>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/0ef82a61a57ae25038cf1b36febe68f9/21b4d/8a3b44ee4261472e4cda4cda6d0de006-tumblr_mv0d3hiVqt1snexhzo1_1280.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.05381165919282%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M160%205c-13%2014-16%2030-9%2052%203%2011%204%2019%202%2024-1%202%200%203%204%208l7%2010%202%205%201-5%201-11v-7l1-2%201-2%201-1c-4-9-4-14-2-20l3-10%201-3v3c0%202%200%202%202%200%201-2%202-2%203-2l1-1c-1-3%200-4%202-3h2l2-1a369%20369%200%200025-1c1%202%206%203%206%201l2-1%201%202h4c2%201%202%201%202-1l2%201h2c1-2%204-2%204-1l1%201c1-1%203%204%203%2010l1%2011-1%2011-3%2012c-1%206-4%2014-7%2018-2%202%200%202%203%201l6-7%202-5h2l1-9c0-8%201-13%208-27s8-20%205-29c-3-10-6-17-11-22l-4-4h-75l-4%205m16%2042c-2%202%200%204%203%204l9%202c2%201%202%201-2%201-5%201-8%203-7%204l3%201h7c2-2%205-2%203%200-1%202%204%201%207-1%205-3%205-6%200-9-7-3-21-5-23-2m46%200l-9%203h-1l-2%203-1%203v2l3%202h1c0%202%208%201%2010-1h4c4%202%207%201%203-1-2-2-9-3-10-2l-1-1c0-1%204-2%2011-2%205%200%205-1%205-3-1-3-6-4-13-3m-43%2057c0%202%2011%2015%2013%2015%201%200%206%208%205%209%200%202%205%205%206%204h3c2%200%204-2%204-4h-3l4-6c7-10%208-10-6-9-14%200-15-1-19-5l-7-4m86%2081c0%201%200%202-2%201-1%200-4%202-4%204l2%202c2%201%201%208-1%2012-1%203-2%204-3%202-2-2-5-1-6%202%200%202%201%203%203%204%201%201%202%201%201%202l-1%202-1%201h-1l-2%202c-3%201-4%204-1%204l4-2%203-2v3c0%203%200%203%202%203%203%200%203%200%202-8%200-9%201-13%203-9l3%2010%203%207v-2l-1-3v-3c-3-6-3-24%200-27%202-3%201-6-1-6-1-1-2%200-2%201m-128%2010c-1%202-2%204-1%206%200%204-2%208-6%208-3%200-3%202-1%207%201%202%202%203%202%201%200-1%201-2%203-1l2-1%202-1%202-1%201-1%201-1c1-1%201-1%203%201l3%202-1-2-1-2-1-3v-2h2l-1-1v-2c-1%201-2-1-4-4-3-6-3-6-5-3m218%2014l-7%201c-5-1-7%200-7%202l-1%203v-3c0-3-4-2-4%201v3h12c15%200%2016-1%2016-3%201-2%201-2%201%201v3l1-3%201-3%201%203c0%203%200%203%201%201h11l2-2c0-2%200-2%201%200l1%203v-3c0-3%200-3-6-3-5%200-6%200-7%202l-1%203v-3c0-2-1-2-6-2l-7-1h-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/0ef82a61a57ae25038cf1b36febe68f9/ca0a1/8a3b44ee4261472e4cda4cda6d0de006-tumblr_mv0d3hiVqt1snexhzo1_1280.webp 223w", "/static/0ef82a61a57ae25038cf1b36febe68f9/75680/8a3b44ee4261472e4cda4cda6d0de006-tumblr_mv0d3hiVqt1snexhzo1_1280.webp 445w", "/static/0ef82a61a57ae25038cf1b36febe68f9/8d1ba/8a3b44ee4261472e4cda4cda6d0de006-tumblr_mv0d3hiVqt1snexhzo1_1280.webp 890w", "/static/0ef82a61a57ae25038cf1b36febe68f9/af3f0/8a3b44ee4261472e4cda4cda6d0de006-tumblr_mv0d3hiVqt1snexhzo1_1280.webp 1280w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/0ef82a61a57ae25038cf1b36febe68f9/e92b6/8a3b44ee4261472e4cda4cda6d0de006-tumblr_mv0d3hiVqt1snexhzo1_1280.png 223w", "/static/0ef82a61a57ae25038cf1b36febe68f9/e66bf/8a3b44ee4261472e4cda4cda6d0de006-tumblr_mv0d3hiVqt1snexhzo1_1280.png 445w", "/static/0ef82a61a57ae25038cf1b36febe68f9/4ef49/8a3b44ee4261472e4cda4cda6d0de006-tumblr_mv0d3hiVqt1snexhzo1_1280.png 890w", "/static/0ef82a61a57ae25038cf1b36febe68f9/21b4d/8a3b44ee4261472e4cda4cda6d0de006-tumblr_mv0d3hiVqt1snexhzo1_1280.png 1280w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/0ef82a61a57ae25038cf1b36febe68f9/4ef49/8a3b44ee4261472e4cda4cda6d0de006-tumblr_mv0d3hiVqt1snexhzo1_1280.png",
              "alt": "8a3b44ee4261472e4cda4cda6d0de006 tumblr mv0d3hiVqt1snexhzo1 1280",
              "title": "8a3b44ee4261472e4cda4cda6d0de006 tumblr mv0d3hiVqt1snexhzo1 1280",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`January is the month of new year's resolutions. Have you been to a gym lately? PACKED! Have you been to a gym in December? `}<em parentName="p">{`empty`}</em></p>
    <p>{`Why is that?`}</p>
    <p>{`People focus on the wrong things, get discouraged, and quit. You can't control the outcomes, but you `}<em parentName="p">{`can`}</em>{` control the inputs.`}</p>
    <p>{`Stoic philosophy in a nutshell. Great philosophy to look into, I recommend reading `}<a parentName="p" {...{
        "href": "https://amzn.to/2H6t6g3"
      }}>{`A Guide to the Good Life`}</a>{`. Amazing book. Very eye-opening.`}</p>
    <p>{`So what does it mean you can't control outcomes?`}</p>
    <p>{`Say you're looking for a job. Trying to get hired as a software engineer at BigCo.`}</p>
    <p>{`What do you do?`}</p>
    <p>{`You apply for jobs. You go to interviews. You get a job.`}</p>
    <p><em parentName="p">{`Multiple`}</em>{` applications. `}<em parentName="p">{`Multiple`}</em>{` interviews. `}<strong parentName="p">{`One`}</strong>{` job.`}</p>
    <p>{`🤔`}</p>
    <p>{`That means there's a funnel. A process, if you will. You are not in control of any one job offer. Somebody else makes that decision based on many factors good and bad. But ultimately it's `}<em parentName="p">{`their`}</em>{` choice, not yours.`}</p>
    <p>{`So you're not in control.`}</p>
    <p>{`But you know that if you apply for 10 jobs, you get 1 interview. If you go to 10 interviews, you get 1 job offer. If you get 10 job offers, you get 3 that fit your criteria.`}</p>
    <p>{`Of those 3, you can negotiate for the best offer.`}</p>
    <p>{`You `}<em parentName="p">{`do`}</em>{` have criteria what you're looking for, don't you? You're not just blindly looking for `}<em parentName="p">{`any`}</em>{` job, are you? You want a `}<em parentName="p">{`good`}</em>{` job? I hope so. I believe in you and think you deserve the dreamiest job you can imagine.`}</p>
    <p>{`Okay, so your goal is to get 3 good job offers. There's probably a time component as well. You need a job before you run out of money.`}</p>
    <p>{`You can't control job offers – the outcomes. You `}<em parentName="p">{`can`}</em>{` control your inputs.`}</p>
    <p>{`So if it takes 10 job offers for 3 good ones, you need 10 offers. If it takes 10 interviews for 1 offer, you need 100 interviews. If it takes 10 applications for 1 interview, you need 1000 applications.`}</p>
    <p>{`And now you're in control.`}</p>
    <p>{`Submit 1000 job applications. Get 100 interviews. Get 10 offers. Get 3 good offers. Have a dream job.`}</p>
    <p>{`Same principle works for the gym: Don't focus on the pounds, backtrack your goal to its inputs, then focus on the process. Doing the work will make the result.`}</p>
    <p>{`Do think `}<em parentName="p">{`"I run 3 miles on Monday, Wednesday, and Friday morning"`}</em>{`, not I want to run a 15K in 5 months, but that's overwhelming, so I'll take a nap instead.`}</p>
    <p>{`Do think `}<em parentName="p">{`"I study for the GMAT for 1 hour every day"`}</em>{`, not I want to get into business school but have to pass the GMAT in March, and that's so overwhelming I can't even get started, so I watch Netflix.`}</p>
    <p>{`Do think `}<em parentName="p">{`"I work on something cool for 1 hour every evening"`}</em>{`, not I want to learn more technologies, but the choice is overwhelming, and I can't keep up.`}</p>
    <h2 {...{
      "id": "my-example-of-process-not-goal-focus"
    }}>{`My example of process-not-goal focus`}</h2>
    <p>{`To share an example, here are my process goals for the start of 2019. In 3 months, I will measure and adjust 👇`}</p>
    <p>{`For general health and well-being:`}</p>
    <ol>
      <li parentName="ol">{`Boxing 4 times per week. Monday, Tuesday, Thursday, Friday`}</li>
      <li parentName="ol">{`Lifting 1x per week. Wednesday`}</li>
      <li parentName="ol">{`Long relaxing walk with The Girl 1x per week. Saturday`}</li>
    </ol>
    <p>{`For my marathon in March. I said no more marathons last year, and yet here we are:`}</p>
    <ol>
      <li parentName="ol">{`Run 5 to 10km twice per week. Wednesday, Friday`}</li>
      <li parentName="ol">{`Run long distance (23km+) every Sunday`}</li>
    </ol>
    <p>{`For my business:`}</p>
    <ol>
      <li parentName="ol">{`Write 2 technical blogs per week. Monday, Wednesday`}</li>
      <li parentName="ol">{`Write 1 soft blog per week. Friday`}</li>
      <li parentName="ol">{`Apply to 1 conference or meetup CFP every week`}</li>
      <li parentName="ol">{`Get in touch with 1 consulting lead per week`}</li>
    </ol>
    <p>{`For business and personal learning:`}</p>
    <ol>
      <li parentName="ol">{`Livecode something cool for at least 1 hour at least 4x per week`}</li>
      <li parentName="ol">{`Write `}<a parentName="li" {...{
          "href": "https://twitter.com/hashtag/200wordsTIL?src=hash"
        }}>{`^200wordsTIL`}</a>{` every day about something new I learned that day`}</li>
    </ol>
    <p>{`My writing comes straight out of your preferences. You can `}<a parentName="p" {...{
        "href": "https://swizecteller.typeform.com/to/GQP8T6"
      }}>{`still answer these 3 questions to make me create better stuff for you`}</a>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2019/01/CleanShot_2019-01-11_at_08.41.36@2x.png",
        "alt": null
      }}></img></p>
    <p>{`What about you? What are you trying to achieve this year? How are you getting there? Can I help?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      